import { render, staticRenderFns } from "./UserPersonalDataForm.vue?vue&type=template&id=0059fa2b&scoped=true&"
import script from "./UserPersonalDataForm.vue?vue&type=script&lang=js&"
export * from "./UserPersonalDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059fa2b",
  null
  
)

export default component.exports